import { AMEX, MA } from '../constants/partnering-networks';
import { AMEX_UNBIND_COOKIE_ERROR, AMEX_UNBIND_PARAM_ERROR } from '../constants/vsb-enums';
/**
 * Processes the responses of vsb network unbind calls
 * @param {array} data Array of network orch/vsb unbind responses
 * @returns {number} number of networks that successfully unbinded
 */
const getSuccessFulUnbindCount = (data = []) => {
  let successfulUnbindCount = Array.isArray(data) ? data.length : 0;
  /*
     * The network sdk responses for unbind are not standardized.
     * Handle different errors to determine if at least one network was successful
     */
  for (const network of data) {
    const networkName = Object.keys(network)[0];
    if (
      network[networkName]?.error !== undefined ||
      (networkName === MA && network[MA]?.status >= 400) ||
      (networkName === AMEX && network[AMEX]?.reason === AMEX_UNBIND_PARAM_ERROR) ||
      (networkName === AMEX && network[AMEX]?.reason === AMEX_UNBIND_COOKIE_ERROR)
    ) {
      successfulUnbindCount -= 1;
    }
  }

  return successfulUnbindCount;
};

export default getSuccessFulUnbindCount;
